import React from 'react'
import { UseFormMethods, useWatch } from 'react-hook-form'
import ControlledTimeInput from 'transfix-form/components/ControlledTimeInput'
import { Box, Grid, makeStyles } from 'transfix-ui/core'
import { TCoverModalSchema } from '../../../../schema/CoverModalSchema'
import FieldWrapper from '../../../FieldWrapper'
import ControlledDatePicker from '../../../controlled/ControlledDatePicker'
import ControlledRadioDateTimeCallback from '../../../controlled/ControlledRadioDateTimeCallback'

const useAssignDriverLaterInputGroupStyles = makeStyles({
  datePicker: {
    '& input': {
      height: '1.875rem',
    },
  },
  bigTimePicker: {
    '& .text-input-container': {
      width: '100%',
    },
  },
})

const NOW = Date.now()

interface IAssignDriverLaterInputGroupProps extends Pick<UseFormMethods, 'control' | 'errors'> {}

export const AssignDriverLaterInputGroup = ({
  control,
  errors,
}: IAssignDriverLaterInputGroupProps) => {
  const useCustomCallback = useWatch<TCoverModalSchema['useCustomCallback']>({
    control,
    name: 'useCustomCallback',
  })

  const classes = useAssignDriverLaterInputGroupStyles()
  return (
    <Box mt={2}>
      <FieldWrapper title='Choose a callback option'>
        <ControlledRadioDateTimeCallback control={control} name='useCustomCallback'>
          {useCustomCallback === 'yes' && (
            <Box mt={1} mb={2} ml={2}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <ControlledDatePicker
                    control={control}
                    name='callbackDate'
                    DatePickerProps={{
                      label: 'Callback Date',
                      className: classes.datePicker,
                      required: true,
                      invalid: Boolean(errors.etaDate),
                      minDate: NOW,
                      size: 'medium',
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ControlledTimeInput
                    control={control}
                    name='callbackTime'
                    TimeInputProps={{
                      label: 'Callback Time',
                      className: classes.bigTimePicker,
                      required: true,
                      invalid: Boolean(errors.etaTime),
                      large: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </ControlledRadioDateTimeCallback>
      </FieldWrapper>
    </Box>
  )
}

export default AssignDriverLaterInputGroup
